import { string, object } from 'yup';

import salesTypes from 'maps/sales-types';
import entityTypes from 'maps/entity-types';

import supportsOneOf from 'helpers/supportsOneOf';

const salesTypeKeys = Object.keys(salesTypes);
const entityTypeValues = entityTypes.map((entity) => entity.value);

export default getSchema;

function getSchema(salesType) {
  if (!salesType) {
    throw new Error('Missing required argument salesType');
  }

  if (!supportsOneOf()) {
    return object({
      selectedSalesType: string().required().default(salesType),
      browseEntityType: string()
        .required()
        .default(() => entityTypeValues[0])
        .test(
          'physical-is-not-track',
          // eslint-disable-next-line no-template-curly-in-string
          'when the ${path} value is track, the selectedSalesType value can not be physical',
          testBrowseEntityType
        ),
    });
  }

  return object({
    selectedSalesType: string()
      .required()
      .oneOf(salesTypeKeys)
      .default(salesType),
    browseEntityType: string()
      .required()
      .oneOf(entityTypeValues)
      .default(() => entityTypeValues[0])
      .test(
        'physical-is-not-track',
        // eslint-disable-next-line no-template-curly-in-string
        'when the ${path} value is track, the selectedSalesType value can not be physical',
        testBrowseEntityType
      ),
  });
}

function testBrowseEntityType(browseEntityType) {
  if (browseEntityType === 'track') {
    if (this.parent.selectedSalesType.value === 'physical') {
      return false;
    }
  }
  return true;
}
